import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isLoggedIn = !!localStorage.getItem('id');
    const userRole = localStorage.getItem('accountType'); // store role at login, e.g., 'admin', 'superadmin', 'user'

    if (!isLoggedIn) {
      this.router.navigate(['/']);
      return false;
    }

    const allowedRoles = route.data['roles'] as Array<string>;

    // If no roles specified, allow all logged-in users
    if (!allowedRoles || allowedRoles.length === 0) {
      return true;
    }

    // Check role
    if (allowedRoles.includes(userRole!)) {
      return true;
    }

    // Role not allowed → redirect
    this.router.navigate(['/unauthorized']);
    return false;
  }
}
